import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Color } from '@sorare/core/src/style/types';

import { StreaksPromotion as StreaksPromotionBanner } from 'components/banners/StreaksPromotion';

import type { StreaksPromotion_anyCardInterface } from './__generated__/index.graphql';

type Props = {
  card: StreaksPromotion_anyCardInterface;
};

export const StreaksPromotion = ({ card }: Props) => {
  const streakTask = card.eligibleUpcomingLeagueTracks.find(
    leagueTrack => leagueTrack.myThresholdsStreakTask
  )?.myThresholdsStreakTask;

  if (!streakTask) {
    return null;
  }
  const promotions = [
    streakTask.rewardTaskCampaign,
    streakTask.scoreTaskCampaign,
  ]
    .filter(Boolean)
    .map(task => ({
      imageSrc: task.tagIconUrl.replace(
        /task_campaigns\/campaigns/,
        'task_campaigns/homepage/campaigns'
      ),
      color: task.color as Color,
      name: task.name,
    }));

  return <StreaksPromotionBanner promotions={promotions} />;
};

StreaksPromotion.fragments = {
  anyCardInterface: gql`
    fragment StreaksPromotion_anyCardInterface on AnyCardInterface {
      slug
      eligibleUpcomingLeagueTracks {
        slug

        myThresholdsStreakTask {
          id
          rewardTaskCampaign {
            slug
            name
            tagIconUrl
            tagLabel
            color(variant: SECONDARY)
          }
          scoreTaskCampaign {
            slug
            name
            tagIconUrl
            tagLabel
            color(variant: SECONDARY)
          }
        }
      }
    }
  ` as TypedDocumentNode<StreaksPromotion_anyCardInterface>,
};
